import { createApp } from 'vue';
import { createStore } from 'vuex';
import './assets/css/tailwind.css';

import App from './App.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft, faArrowRight, faCheck, faRotateRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import questions from '@/assets/questions/questions.json';
import results from '@/assets/questions/results.json';

library.add(faArrowRight, faArrowLeft, faCheck, faRotateRight);

const store = createStore({
	state() {
		return {
			helloView: true,
			quizView: false,
			resultView: false,
			confirmView: false,
			questions: questions,
			answers: [],
			progress: 0,
			total: questions.length,
			direction: true, // true up, false down
			results: results,
		};
	},

	mutations: {
		showQuiz(state) {
			state.quizView = true;
			state.confirmView = false;
		},

		showConfirm(state) {
			state.helloView = false;
			state.confirmView = true;
		},

		apply(state, answer) {
			if (typeof state.answers[state.progress] != 'undefined') {
				state.answers[state.progress] = answer;

				return;
			}

			state.answers.push(answer);
		},

		next(state) {
			state.direction = true;

			if (state.answers.length === state.total) {
				state.quizView = false;
				state.resultView = true;

				return;
			}

			state.progress++;
		},

		prev(state) {
			state.direction = false;
			state.progress--;
		},

		reset(state) {
			state.helloView = true;
			state.confirmView = false;
			state.quizView = false;
			state.resultView = false;

			state.progress = 0;
			state.answers = [];
		},
	},
	getters: {
		current(state) {
			return state.questions[state.progress];
		},

		selected(state) {
			return state.answers[state.progress];
		},

		result(state) {

			if (!state.answers.length || state.questions.length != state.answers.length) return false;

			// Count occurrences of each value
			const count = { creator: 0, explorer: 0, champion: 0 };

			// Loop through the first 6 items to count occurrences
			state.answers.slice(0, 6).forEach(item => {
				count[item]++;
			});
		
			// Determine the most common value for the first 6 items
			let common = Object.keys(count).reduce((a, b) => count[a] > count[b] ? a : b);
		
			// Handle the 7th item (index 6)
			if (state.answers.length > 6) {
				const seventhItem = state.answers[6];
				
				if (count['creator'] === count['champion'] && seventhItem === 'creator') {
					common = 'creator'; // Creator wins in a tie with champion
				} else if (count['champion'] === count['explorer'] && seventhItem === 'champion') {
					common = 'champion'; // Champion wins in a tie with explorer
				} else if (count['creator'] === count['explorer'] && seventhItem === 'creator') {
					common = 'creator'; // Creator wins in a tie with explorer
				}
			}

			return state.results[common];
		},
	},
});

createApp(App).use(store).component('font-awesome-icon', FontAwesomeIcon).mount('#app');
